<template>
  <div class="px-5 content-page talk">
    <p class="pb-3 pt-5 title" v-html="$t('contact.content.formularioComent.title')"/>
    <div class="col-12">
    <b-form @submit="sendForm" ref="formContainer">
      <b-form-row>
        <b-form-group class="text col-sm-12 col-md-5" :label="$t('contact.content.formularioComent.pregunta0')">
          <b-form-input class="form-input" type="text" v-model="form.name" required :placeholder="$t('contact.content.form.name')"/>
        </b-form-group>
        <b-form-group class="col-2 d-none d-sm-block"></b-form-group>
        <b-form-group class="text col-sm-12 col-md-5" :label="$t('contact.content.formularioComent.pregunta1')">
          <b-form-input class="form-input" type="email" v-model="form.email" required :placeholder="$t('contact.content.form.email')"/>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group class="text col-sm-12 col-md-5" :label="$t('contact.content.formularioComent.pregunta2')">
          <b-form-input class="form-input" type="text" v-model="form.company" required :placeholder="$t('contact.content.form.empresa')"/>
        </b-form-group>
        <b-form-group class="col-2 d-none d-sm-block"></b-form-group>
        <b-form-group class="text col-sm-12 col-md-5" :label="$t('contact.content.formularioComent.pregunta3')">
          <b-form-input class="form-input" type="text" v-model="form.location" required :placeholder="$t('contact.content.form.ubicacion')"/>
        </b-form-group>
      </b-form-row>

      <b-form-row>

        <b-form-group class="text col-sm-12 col-md-5" :label="$t('contact.content.formularioComent.pregunta4')">
          <b-form-textarea class="form-input"
                           type="text"
                           v-model="form.about"
                           required
                           :placeholder="$t('contact.content.form.message')"></b-form-textarea>
        </b-form-group>
        <b-form-group class="col-2 d-none d-sm-block"></b-form-group>
        <b-form-group class="text col-sm-12 col-md-5 py-5" >
          <vue-recaptcha @verify="verified" @expired="expired" sitekey="6Lek8yUTAAAAANOZAJK2w53SpsmmOqPLQOJhOaCs"></vue-recaptcha>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group class="col-md-3 d-none d-md-block"></b-form-group>
        <b-form-group class="text col-sm-6 col-md-2">
          <b-button type="button" class="btn-cancel float-center" @click="cancelForm">
            {{$t('contact.content.form.cancel')}}
          </b-button></b-form-group>
        <b-form-group class="col-2 d-none d-md-block"></b-form-group>

        <b-form-group class="text col-sm-6 col-md-2">
          <b-button :disabled="!captcha" type="submit" class="btn-submit float-center">
            {{$t('contact.content.form.submit')}}
          </b-button> </b-form-group>
      </b-form-row>

    </b-form>
    </div>
    <b-modal ref="myModalRef" hide-footer title="">
      <div class="d-block text-center">
        <h3>We can't connect your request. </h3>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'

  export default {
    name: 'ContactForm',
    components: { VueRecaptcha },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        captcha: false,
        form: {
          name: '',
          company: '',
          email: '',
          location: '',
          about: ''
        }

      }
    },
    methods: {
      verified (e) {
        this.captcha = true
      },
      expired (e) {
        this.captcha = false
      },
      sendForm: function (e) {
        e.preventDefault()
        let loader = this.$loading.show({
          loader: 'dots',
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          color: '#EC8409'
        })
        this.$http.post('contact', JSON.stringify(this.form))
          .then(response => {
            this.$emit('gratitude', '')
            loader.hide()
            this.$router.push({name: 'Gratitude'})
          }).catch((err) => {
            console.log(err, 'error')
            loader.hide()
            this.$refs.myModalRef.show()
          })
      },
      cancelForm: function () {
        this.$emit('cancel', '')
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" >
  @import '../assets/styles/contactForm';

</style>



// WEBPACK FOOTER //
// src/pages/ContactForm.vue